"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/verification-method.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Fverification-method.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlternativePhoneVerificationMethod = exports.AppleSsoVerificationMethod = exports.GoogleSsoVerificationMethod = exports.EmailVerificationMethod = exports.PhoneVerificationMethod = exports.VerificationMethod = void 0;
const credentials_1 = require("../auth/credentials");
const protobufPackage = 'com.step.user.proto';
function createBaseVerificationMethod() {
    return {
        phone: undefined,
        email: undefined,
        google: undefined,
        apple: undefined,
        alternativePhone: undefined,
    };
}
exports.VerificationMethod = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.phone)) {
            message.phone = exports.PhoneVerificationMethod.fromJSON(object.phone);
        }
        if (isSet(object.email)) {
            message.email = exports.EmailVerificationMethod.fromJSON(object.email);
        }
        if (isSet(object.google)) {
            message.google = exports.GoogleSsoVerificationMethod.fromJSON(object.google);
        }
        if (isSet(object.apple)) {
            message.apple = exports.AppleSsoVerificationMethod.fromJSON(object.apple);
        }
        if (isSet(object.alternativePhone)) {
            message.alternativePhone = exports.AlternativePhoneVerificationMethod.fromJSON(object.alternativePhone);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phone !== undefined) {
            obj.phone = exports.PhoneVerificationMethod.toJSON(message.phone);
        }
        if (message.email !== undefined) {
            obj.email = exports.EmailVerificationMethod.toJSON(message.email);
        }
        if (message.google !== undefined) {
            obj.google = exports.GoogleSsoVerificationMethod.toJSON(message.google);
        }
        if (message.apple !== undefined) {
            obj.apple = exports.AppleSsoVerificationMethod.toJSON(message.apple);
        }
        if (message.alternativePhone !== undefined) {
            obj.alternativePhone = exports.AlternativePhoneVerificationMethod.toJSON(message.alternativePhone);
        }
        return obj;
    },
    create(base) {
        return exports.VerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerificationMethod();
        message.phone = (object.phone !== undefined && object.phone !== null)
            ? exports.PhoneVerificationMethod.fromPartial(object.phone)
            : undefined;
        message.email = (object.email !== undefined && object.email !== null)
            ? exports.EmailVerificationMethod.fromPartial(object.email)
            : undefined;
        message.google = (object.google !== undefined && object.google !== null)
            ? exports.GoogleSsoVerificationMethod.fromPartial(object.google)
            : undefined;
        message.apple = (object.apple !== undefined && object.apple !== null)
            ? exports.AppleSsoVerificationMethod.fromPartial(object.apple)
            : undefined;
        message.alternativePhone =
            (object.alternativePhone !== undefined && object.alternativePhone !== null)
                ? exports.AlternativePhoneVerificationMethod.fromPartial(object.alternativePhone)
                : undefined;
        return message;
    },
};
function createBasePhoneVerificationMethod() {
    return { phoneNumber: '' };
}
exports.PhoneVerificationMethod = {
    fromJSON(object) {
        const message = {
            phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phoneNumber !== '') {
            obj.phoneNumber = message.phoneNumber;
        }
        return obj;
    },
    create(base) {
        return exports.PhoneVerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePhoneVerificationMethod();
        message.phoneNumber = object.phoneNumber ?? '';
        return message;
    },
};
function createBaseEmailVerificationMethod() {
    return { emailAddress: '' };
}
exports.EmailVerificationMethod = {
    fromJSON(object) {
        const message = {
            emailAddress: isSet(object.emailAddress) ? globalThis.String(object.emailAddress) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.emailAddress !== '') {
            obj.emailAddress = message.emailAddress;
        }
        return obj;
    },
    create(base) {
        return exports.EmailVerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmailVerificationMethod();
        message.emailAddress = object.emailAddress ?? '';
        return message;
    },
};
function createBaseGoogleSsoVerificationMethod() {
    return { googleIdToken: '' };
}
exports.GoogleSsoVerificationMethod = {
    fromJSON(object) {
        const message = {
            googleIdToken: isSet(object.googleIdToken) ? globalThis.String(object.googleIdToken) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.googleIdToken !== '') {
            obj.googleIdToken = message.googleIdToken;
        }
        return obj;
    },
    create(base) {
        return exports.GoogleSsoVerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGoogleSsoVerificationMethod();
        message.googleIdToken = object.googleIdToken ?? '';
        return message;
    },
};
function createBaseAppleSsoVerificationMethod() {
    return { appleIdCredential: credentials_1.AppleIdCredential.fromPartial({}) };
}
exports.AppleSsoVerificationMethod = {
    fromJSON(object) {
        const message = {
            appleIdCredential: isSet(object.appleIdCredential)
                ? credentials_1.AppleIdCredential.fromJSON(object.appleIdCredential)
                : credentials_1.AppleIdCredential.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.appleIdCredential !== undefined) {
            obj.appleIdCredential = credentials_1.AppleIdCredential.toJSON(message.appleIdCredential);
        }
        return obj;
    },
    create(base) {
        return exports.AppleSsoVerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAppleSsoVerificationMethod();
        message.appleIdCredential =
            (object.appleIdCredential !== undefined && object.appleIdCredential !== null)
                ? credentials_1.AppleIdCredential.fromPartial(object.appleIdCredential)
                : credentials_1.AppleIdCredential.fromPartial({});
        return message;
    },
};
function createBaseAlternativePhoneVerificationMethod() {
    return { previousPhone: '' };
}
exports.AlternativePhoneVerificationMethod = {
    fromJSON(object) {
        const message = {
            previousPhone: isSet(object.previousPhone) ? globalThis.String(object.previousPhone) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.previousPhone !== '') {
            obj.previousPhone = message.previousPhone;
        }
        return obj;
    },
    create(base) {
        return exports.AlternativePhoneVerificationMethod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAlternativePhoneVerificationMethod();
        message.previousPhone = object.previousPhone ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=verification-method.js.map